

import Vue from 'vue'
import App from './App'
import router from './router'
import './utils/filter'
import store from './store/store'

import '../static/main.css'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

Vue.use(ToastPlugin,{time: '5000'})
Vue.use(ConfirmPlugin)

Vue.config.productionTip = false









var xStart, xEnd, yStart, yEnd;

document.addEventListener("touchstart", function (evt) {
xStart = evt.touches[0].pageX;
yStart = evt.touches[0].pageY;
}, false);

document.addEventListener('touchmove', function (evt) {
xEnd = evt.touches[0].pageX;
yEnd = evt.touches[0].pageY;

if(Math.abs(xStart - xEnd) > Math.abs(yStart - yEnd)){
evt.preventDefault();
}
}, false);

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js